// AnimatedBackground.tsx
import React from 'react';
import { motion } from 'framer-motion';
import TechIcons from './TechIcons';

const AnimatedBackground = () => {
  const techIcons = [
    { name: 'Kubernetes', svg: TechIcons.Kubernetes, position: { x: '10%', y: '20%' }, delay: 0 },
    { name: 'Ansible', svg: TechIcons.Ansible, position: { x: '60%', y: '85%' }, delay: 0.5 },
    { name: 'DigitalOcean', svg: TechIcons.DigitalOcean, position: { x: '15%', y: '70%' }, delay: 1 },
    { name: 'Docker', svg: TechIcons.Docker, position: { x: '75%', y: '82%' }, delay: 1.5 },
    { name: 'Python', svg: TechIcons.Python, position: { x: '25%', y: '85%' }, delay: 2 },
    { name: 'Kafka', svg: TechIcons.Kafka, position: { x: '85%', y: '88%' }, delay: 2.5 },
    { name: 'Go', svg: TechIcons.Go, position: { x: '15%', y: '45%' }, delay: 3 },
    { name: 'Redis', svg: TechIcons.Redis, position: { x: '45%', y: '10%' }, delay: 3.5 },
    { name: 'Terraform', svg: TechIcons.Terraform, position: { x: '25%', y: '25%' }, delay: 3.5 },
    { name: 'Apple', svg: TechIcons.Apple, position: { x: '85%', y: '8%' }, delay: 3.5 },
  ];

  const animationVariants = {
    animate: {
      opacity: [0.3, 0.9, 0.3],
      scale: [1, 1.05, 1],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {techIcons.map((icon) => (
        <motion.div
          key={icon.name}
          className="absolute text-gray-500/70 dark:text-gray-400/50"
          style={{ left: icon.position.x, top: icon.position.y }}
          initial={{ opacity: 0, scale: 0 }}
          animate={animationVariants.animate}
          transition={{ delay: icon.delay, duration: 1, ease: 'easeOut' }}
          whileHover={{ scale: 1.2, opacity: 0.8, transition: { duration: 0.3 } }}
        >
          {icon.svg}
        </motion.div>
      ))}

      {/* Floating Blobs */}
      <motion.div
        className="absolute w-32 h-32 bg-gradient-to-r from-primary-200/20 to-blue-200/20 rounded-full blur-xl"
        style={{ left: '20%', top: '30%' }}
        animate={{ scale: [1, 1.5, 1], opacity: [0.1, 0.3, 0.1], rotate: [0, 180, 360] }}
        transition={{ duration: 15, repeat: Infinity, ease: 'linear' }}
      />

      <motion.div
        className="absolute w-24 h-24 bg-gradient-to-r from-blue-200/20 to-purple-200/20 rounded-full blur-xl"
        style={{ right: '25%', bottom: '20%' }}
        animate={{ scale: [1, 1.3, 1], opacity: [0.1, 0.2, 0.1], rotate: [360, 180, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
      />
    </div>
  );
};

export default AnimatedBackground;
